import { ItemStatus } from '@/redux/back-dashboard-api';
import * as yup from 'yup';

const { array, object, mixed, string } = yup;

export const updateOrderItemStatusSchema = object({
  items: array(
    object({
      from: mixed<ItemStatus>().required().oneOf(Object.values(ItemStatus)),
      to: mixed<ItemStatus>()
        .required()
        .oneOf(Object.values(ItemStatus))
        .test(
          'has-changed',
          'error.form.newStatusHasChanged',
          (value, schema) => value !== schema.parent.from
        ),
      reason: string(),
      warehouseId: string().when('to', {
        is: ItemStatus.Prepared,
        then: (schema) => schema.required(),
      }),
    })
  ).required(),
  comments: string().max(2000).required(),
});

export type UpdateOrderItemStatusFormData = yup.InferType<
  typeof updateOrderItemStatusSchema
>;
